import { APPLICANT_TYPES } from "constants/index";

const SORT = {
  asc: "asc",
  desc: "desc",
};

const APPLICANT_LIST_KEYWORD_SEARCH_SORT = {
  sortKey: "relevanceScore",
  sortDirection: SORT.desc,
};

const NETWORK_PAGE_KEYWORD_SEARCH_SORT = {
  sortKey: "_score",
  sortDirection: SORT.desc,
};

const APPLICANT_LIST_SORTING_OPTIONS = [
  {
    label: "Relevance",
    value: "relevance",
  },
  {
    label: "Relevance Score",
    value: "relevanceScore",
  },
  {
    label: "AI Rank",
    value: "rankVector",
  },
  {
    label: "Profile Name",
    value: "profileName",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Progress Percentage",
    value: "applicationProgressPercentage",
    columnTooltips: {
      checklistPercentage: "Missions.Applicants.ApplicantChecklist.DelayWarning",
    },
    restrict: {
      states: [
        APPLICANT_TYPES.pending,
        APPLICANT_TYPES.applied,
        APPLICANT_TYPES.shortlisted,
        APPLICANT_TYPES.interviewed,
        APPLICANT_TYPES.selected,
        APPLICANT_TYPES.unselected,
      ],
    },
  },
];

export default SORT;

export { APPLICANT_LIST_SORTING_OPTIONS, NETWORK_PAGE_KEYWORD_SEARCH_SORT, APPLICANT_LIST_KEYWORD_SEARCH_SORT };
